import { REFERRAL_QUERY_KEY } from '../constants/key';

export const buildRefCodeLink = (code: string) => {
  return `${window.location.origin}${window.location.pathname}?${REFERRAL_QUERY_KEY}=${code}`;
};
